import type { IntlShape } from 'react-intl'
import type { HrcConnectSubject } from './types'

/** The roster's own name where there is one; names are never translated. */
export function subjectLabel(subject: HrcConnectSubject, intl: IntlShape): string {
  return (
    subject.name?.trim() ||
    intl.formatMessage({
      id: subject.role === 'SELF' ? 'healthRecords.section.tabSelf' : 'healthRecords.section.tabChild',
    })
  )
}
